import { cn } from "@/lib/helpers/cn";

type EscalationLabelProps = {
  escalationLevel: number;
};

export function EscalationLabel({ escalationLevel }: EscalationLabelProps) {
  const isEscalating = escalationLevel > 0;

  return (
    <span className={cn("tw:text-sm", isEscalating && "tw:text-text-error-primary!")}>
      {Math.abs(escalationLevel)} level {isEscalating ? "increase" : "decrease"}
    </span>
  );
}
